<script setup>
const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
})
let headingStyle = 'font-family: var(--heading-font, var(--font));';
if (props.row.content.font !== undefined && props.row.content.font !== '' && props.row.content.font !== null) headingStyle = 'font-family: ' + props.row.content.font.replace(/\_/g, ' ') + ';';
if (props.row.content.bold === false) headingStyle += 'font-weight: 400;';
if (props.row.content.italic) headingStyle += 'font-style: italic;';
</script>
<template>
    <div class="relative p-fl-4 w-full">
        <div
            class="font-black w-full transition-all"
            :class="row.content.titleSize"
            :style="headingStyle"
            v-text="row.content.content"
        />
    </div>
</template>